import Record from "slotworks/model/gameplay/records/record";
import LineResult from "slotworks/model/gameplay/records/results/line-result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { DataProcessorSupplement } from "slotworks/model/gameplay/supplements/data-processor-supplement";

class RightToLeftWinsLastSupplement implements DataProcessorSupplement {
    /**
     * Orders right to left paying line wins last
     */
    public process(record: Record) {

        if (record && record instanceof SpinRecord) {
            if (record.results) {

                const otherResults = [];
                const rightToLeftResults = [];

                while (record.results.length) {
                    const result = record.results.shift();

                    if (result instanceof LineResult && result.positions[0].x !== 0) {
                        rightToLeftResults.push(result);
                    } else {
                        otherResults.push(result);
                    }
                }

                record.results = [...otherResults, ...rightToLeftResults];
            }
        }
    }
}

export default new RightToLeftWinsLastSupplement();
